import { useState } from "react";
import { Box, Typography } from "@mui/material";
import TableTopBar from "../component/TableTopBar";
import DataChatPanel from "../component/DataChatPanel";

function DataAnalysis() {
  const [serchOpen, setSerchOpen] = useState(false);

  return (
    <Box
      data-testid="data-analysis-page"
      style={{
        width: "calc(100% - 31px)",
        height: "calc(100vh - 40px)",
      }}
    >
      <TableTopBar
        serch={false}
        serchOpen={serchOpen}
        setSerchOpen={setSerchOpen}
        addDataNames={[]}
        addDataName=""
        setAddDataName={() => {}}
        addCSVDataNames={[]}
        addCSVDataName=""
        setAddCSVDataName={() => {}}
        getXLSXDataNames={[]}
        getXLSXDataName=""
        setGetXLSXDataName={() => {}}
        editDatasNames={[]}
        editDatasName=""
        setEditDatasName={() => {}}
        editIDs={[]}
        columnSettingOpen={false}
        openColumnSettingWindow={() => {}}
      />
      <Box
        sx={{
          height: "calc(100vh - 80px)",
          overflow: "hidden",
        }}
      >
        <Typography
          variant="h6"
          className="shippori-antique-regular"
          sx={{ px: 2, pt: 1, pb: 0.5 }}
        >
          AIデータ分析
        </Typography>
        <Box sx={{ height: "calc(100vh - 120px)" }}>
          <DataChatPanel />
        </Box>
      </Box>
    </Box>
  );
}

export default DataAnalysis;
